<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="$store.state.preprojects.loadingPreProjects"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.preprojects.preProjectsCount"
				:loading-info="$store.state.preprojects.loadingPreProjects"
				:showOrderBy="true"
				items-type="preprojects"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				ref="table"
				:headers="headers"
				:items="$store.state.preprojects.preProjects"
				item-key="id"
				:loading="$store.state.preprojects.loadingPreProjects"
				:server-items-length="$store.state.preprojects.preProjectsCount"
				:options.sync="options"
				loading-text="Cargando datos..."
				class="crm-table"
				:class="$vuetify.breakpoint.mobile ? '':'resizable'"
				disable-sort
				hide-default-header
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:header="{ props }" v-if="!$vuetify.breakpoint.mobile">
					<thead class="v-data-table-header">
						<tr>
							<th role="columnheader" scope="col" aria-label="#" class="header-cell"
								:style="{
									width: head.width ? head.width + 'px' : 'auto',
									maxHeight: ['unarchive','instalations','cbr','sii'].includes(head.value) ? null : '30px',
									height: ['unarchive','instalations','cbr','sii'].includes(head.value) ? null : '25px',
									padding: ['unarchive','instalations','cbr','sii'].includes(head.value) ? '0' : null
								}"
								:class="head.align == 'center' ? 'text-center':''"
								v-for="(head,index) in props.headers" :key="'h-'+index"
								@mouseup="saveColumnWidth(index)"
							>
								<div v-if="head.value == 'unarchive'">
									<div class="pa-1 text-center">
										{{ head.text }}
									</div>
									<div class="d-flex">
										<div
											style="flex: 1;"
											v-for="(tooltip, i) in unarchive"
											:key="'una'+i"
											class="text-center subcolumn-header"
											:class="{
												'no-border': i === unarchive.length - 1
											}"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">{{ tooltip.text }}</div>
												</template>
												<span>{{ tooltip.label }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
								<div v-else-if="head.value == 'instalations'">
									<div class="pa-1 text-center">
										{{ head.text }}
									</div>
									<div class="d-flex">
										<div
											style="flex: 1;"
											v-for="(tooltip, i) in instalations"
											:key="'insa'+i"
											class="text-center subcolumn-header"
											:class="{
												'no-border': i === instalations.length - 1
											}"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">{{ tooltip.text }}</div>
												</template>
												<span>{{ tooltip.label }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
								<div v-else-if="head.value == 'cbr'">
									<div class="pa-1 text-center">
										{{ head.text }}
									</div>
									<div class="d-flex">
										<div
											style="flex: 1;"
											v-for="(tooltip, i) in cbr"
											:key="'cbra'+i"
											class="text-center subcolumn-header"
											:class="{
												'no-border': i === cbr.length - 1
											}"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">{{ tooltip.text }}</div>
												</template>
												<span>{{ tooltip.label }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
								<div v-else-if="head.value == 'sii'">
									<div class="pa-1 text-center">
										{{ head.text }}
									</div>
									<div class="d-flex">
										<div
											style="flex: 1;"
											v-for="(tooltip, i) in sii"
											:key="'siia'+i"
											class="text-center subcolumn-header"
											:class="{
												'no-border': i === sii.length - 1
											}"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">{{ tooltip.text }}</div>
												</template>
												<span>{{ tooltip.label }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
								<div v-else-if="head.value == 'sec'">
									<div class="pa-1 text-center">
										{{ head.text }}
									</div>
									<div class="d-flex">
										<div
											style="flex: 1;"
											v-for="(tooltip, i) in sec"
											:key="'seca'+i"
											class="text-center subcolumn-header"
											:class="{
												'no-border': i === sec.length - 1
											}"
										>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">{{ tooltip.text }}</div>
												</template>
												<span>{{ tooltip.label }}</span>
											</v-tooltip>
										</div>
									</div>
								</div>
								<span v-else>{{ head.text }}</span>
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item.id="{ item }">
					<div>
						<div class="d-flex align-center">
							<p class="mb-1 mr-1 font-weight-bold">LP {{ item.project_line_info?.project_line?.number }}</p>
							<ProjectLineAssociationMenu :projectLineAssociations="item.associations" :btnClick="() => selectRow(item)"/>
						</div>
						<div class="d-flex align-center">
							<ProjectLineAssociationIcons :projectLineAssociations="item.associations" />
						</div>
					</div>
				</template>
				<template v-slot:item.client="{ item }">
					<div class="d-flex align-center">
						<div class="d-flex flex-column flex-grow-1">
							<b>{{ getUserName(item) }}</b>
							<div v-if="item.client">{{ item.client ? item.client.email:'No identificado'}}</div>
						</div>
						<div class="d-flex align-self-start align-start justify-end">
							<v-tooltip bottom v-if="item.client?.company_profile && item.client?.accreditation?.status">
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#FF1209"
										v-bind="attrs"
										v-on="on">mdi-domain</v-icon>
								</template>
								<span>Cliente Empresa</span>
							</v-tooltip>
							<v-tooltip bottom v-else>
								<template v-slot:activator="{ on, attrs }">
									<v-icon small color="#959595"
										v-bind="attrs"
										v-on="on">mdi-account</v-icon>
								</template>
								<span>Cliente Persona Natural</span>
							</v-tooltip>
						</div>
					</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div><b>{{ item.info ? item.info.address?.address:'Sin registro'}}</b></div>
				</template>
				<template v-slot:item.rol="{ item }">
					<div><b>{{ item.info ? item.info.address?.rol:'Sin registro'}}</b></div>
				</template>
				<template v-slot:item.project_name="{ item }">
					<div class="d-flex justify-space-between align-center mt-1">
						<b>{{ item.name }}</b>
						<ProjectLineAssociationMenu :projectLineAssociations="item.associations" :btnClick="() => selectRow(item)"/>
					</div>
					<v-divider class="my-1"></v-divider>
					<div class="d-flex justify-space-between align-center">
						<b class="mr-2">[{{ item.info?.project_type?.code }}] {{ item.info?.project_type?.name }}</b>
						<ProjectTypeSelectorMenu :onClick="(project_type) => { selectRow(item); changeProjectType(item, project_type.id); }"/>
					</div>
				</template>
				<template v-slot:item.entity="{ item, index }">
					<div>
						<b>{{item.info?.address?.district?.name ?? '--'}}</b>
						<v-menu :ref="'cityMenu-' + index" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									dark
									small
									icon
									color="#524D4D"
									@click="selectRow(item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
								</v-btn>
							</template>
							<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
								<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
									<p class="caption mb-0 font-weight-bold white--text">Cambiar Municipalidad</p>
								</v-list-item>
								<v-list-item dense class="mb-1 px-1" style="min-height: 25px;">
									<v-text-field
										v-model="searchCity"
										label="Filtro"
										placeholder="Búsqueda"
										outlined
										required
										dense
										hide-details
										class="custom-height-search custom-height-calendar"
										style="max-width: 160px;"
									></v-text-field>
								</v-list-item>
								<v-list-item-group color="#524D4D">
									<v-list-item
										v-for="(city, index) in cities"
										:key="'city'+index"
										dense
										@click.stop="() => { selectRow(item); changePreProjectCity(item, city.id); }"
									>
										<v-list-item-title dense>
											{{ city.name }}
										</v-list-item-title>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</v-menu>
					</div>
				</template>
				<template v-slot:item.unarchive="{ item }">
					<td class="pa-0">
						<div class="d-flex fill-height align-stretch">
							<div
								style="flex: 1;"
								v-for="(un, i) in unarchive"
								:key="'u'+i"
								class="text-center subcolumn"
								:class="{
									'no-border': i === unarchive.length - 1
								}"
							>
								<v-tooltip bottom content-class="tooltip-arc-status">
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											v-if="status(item, un.id)"
											:color="status(item, un.id)?.color"
											v-bind="attrs"
											v-on="on"
											small>{{ status(item, un.id)?.icon }}</v-icon>
										<div v-else>-</div>
									</template>
									<div v-if="status(item, un.id)">
										<p class="mb-0 caption font-weight-bold">{{ status(item, un.id)?.label }}</p>
										<p class="mb-0 caption">{{status(item, un.id)?.label == 'Entregado' ? 'Entregado':'Solicitado'}}: {{getPreProjectDocument(item, un.id).delivered_date ?? getPreProjectDocument(item, un.id).request_date | toDate}}</p>
									</div>
								</v-tooltip>
							</div>
						</div>
					</td>
				</template>
				<template v-slot:item.cbr="{ item }">
					<td class="pa-0">
						<div class="d-flex fill-height align-stretch">
							<div
								style="flex: 1;"
								v-for="(cbr_i, i) in cbr"
								:key="'cbr'+i"
								class="text-center subcolumn"
								:class="{
									'no-border': i === cbr.length - 1
								}"
							>
								<v-tooltip bottom content-class="tooltip-arc-status">
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											v-if="status(item, cbr_i.id)"
											:color="status(item, cbr_i.id).color"
											v-bind="attrs"
											v-on="on"
											small>{{ status(item, cbr_i.id).icon }}</v-icon>
										<div v-else>-</div>
									</template>
									<div v-if="status(item, cbr_i.id)">
										<p class="mb-0 caption font-weight-bold">{{ status(item, cbr_i.id).label }}</p>
										<p class="mb-0 caption">{{status(item, cbr_i.id).label == 'Entregado' ? 'Entregado':'Solicitado'}}: {{getPreProjectDocument(item, cbr_i.id).delivered_date ?? getPreProjectDocument(item, cbr_i.id).request_date | toDate}}</p>
									</div>
								</v-tooltip>
							</div>
						</div>
					</td>
				</template>
				<template v-slot:item.instalations="{ item }">
					<td class="pa-0">
						<div class="d-flex fill-height align-stretch">
							<div
								style="flex: 1;"
								v-for="(instalation, i) in instalations"
								:key="'ins'+i"
								class="text-center subcolumn"
								:class="{
									'no-border': i === instalations.length - 1
								}"
							>
								<v-tooltip bottom content-class="tooltip-arc-status">
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											v-if="status(item, instalation.id)"
											:color="status(item, instalation.id).color"
											v-bind="attrs"
											v-on="on"
											small>{{ status(item, instalation.id).icon }}</v-icon>
										<div v-else>-</div>
									</template>
									<div v-if="status(item, instalation.id)">
										<p class="mb-0 caption font-weight-bold">{{ status(item, instalation.id).label }}</p>
										<p class="mb-0 caption">{{status(item, instalation.id).label == 'Entregado' ? 'Entregado':'Solicitado'}}: {{getPreProjectDocument(item, instalation.id).delivered_date ?? getPreProjectDocument(item, instalation.id).request_date | toDate}}</p>
									</div>
								</v-tooltip>
							</div>
						</div>
					</td>
				</template>
				<template v-slot:item.sii="{ item }">
					<td class="pa-0">
						<div class="d-flex fill-height align-stretch">
							<div
								style="flex: 1;"
								v-for="(sii_i, i) in sii"
								:key="'sii'+i"
								class="text-center subcolumn"
								:class="{
									'no-border': i === sii.length - 1
								}"
							>
								<v-tooltip bottom content-class="tooltip-arc-status">
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											v-if="status(item, sii_i.id)"
											:color="status(item, sii_i.id).color"
											v-bind="attrs"
											v-on="on"
											small>{{ status(item, sii_i.id).icon }}</v-icon>
										<div v-else>-</div>
									</template>
									<div v-if="status(item, sii_i.id)">
										<p class="mb-0 caption font-weight-bold">{{ status(item, sii_i.id).label }}</p>
										<p class="mb-0 caption">{{status(item, sii_i.id).label == 'Entregado' ? 'Entregado':'Solicitado'}}: {{getPreProjectDocument(item, sii_i.id).delivered_date ?? getPreProjectDocument(item, sii_i.id).request_date | toDate}}</p>
									</div>
								</v-tooltip>
							</div>
						</div>
					</td>
				</template>
				<template v-slot:item.sec="{ item }">
					<td class="pa-0">
						<div class="d-flex fill-height align-stretch">
							<div
								style="flex: 1;"
								v-for="(sec_i, i) in sec"
								:key="'sec'+i"
								class="text-center subcolumn"
								:class="{
									'no-border': i === sec.length - 1
								}"
							>
								<v-tooltip bottom content-class="tooltip-arc-status">
									<template v-slot:activator="{ on, attrs }">
										<v-icon
											v-if="status(item, sec_i.id)"
											:color="status(item, sec_i.id).color"
											v-bind="attrs"
											v-on="on"
											small>{{ status(item, sec_i.id).icon }}</v-icon>
										<div v-else>-</div>
									</template>
									<div v-if="status(item, sec_i.id)">
										<p class="mb-0 caption font-weight-bold">{{ status(item, sec_i.id).label }}</p>
										<p class="mb-0 caption">{{status(item, sec_i.id).label == 'Entregado' ? 'Entregado':'Solicitado'}}: {{getPreProjectDocument(item, sec_i.id).delivered_date ?? getPreProjectDocument(item, sec_i.id).request_date | toDate}}</p>
									</div>
								</v-tooltip>
							</div>
						</div>
					</td>
				</template>
				<template v-slot:item.responsible="{ item }">
					<div>
						<b>{{item.responsible?.profile?.name ?? '--'}}</b>
						<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									dark
									small
									icon
									color="#524D4D"
									@click="selectRow(item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
								</v-btn>
							</template>
							<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
								<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
									<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
								</v-list-item>
								<v-list-item-group color="#524D4D">
									<v-list-item
										v-for="(responsible, index) in $store.state.users.usersList"
										:key="'user'+index"
										dense
										@click.stop="() => { selectRow(item); changePreProjectResponsible(item, responsible.id); }"
									>
										<v-list-item-title dense>
											<div class="d-flex align-center">
												<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
												<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
												<div>
													<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
													<p class="mb-0 caption">{{ responsible.email }}</p>
												</div>
											</div>
										</v-list-item-title>
									</v-list-item>
								</v-list-item-group>
							</v-list>
						</v-menu>
					</div>
				</template>
				<template v-slot:item.observation="{ item }">
					<div><b>{{item.description ?? '--'}}</b></div>
				</template>
				<template v-slot:item.status="{ item }">
					<div>
						<div class="d-flex align-center">
							<div>
								<v-chip
									:color="item.last_status?.status | preprojectStatusColor"
									label
									outlined
									x-small
									class="px-1"
								>
									<b>{{ item.last_status?.status | preprojectStatus }}</b>
								</v-chip>
								<p class="ml-2 mb-0 caption">{{ item.last_status?.description }}</p>
							</div>

							<v-menu offset-y z-index="9999" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										icon
										color="#524D4D"
										@click="selectRow(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
									</v-btn>
								</template>
								<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
									<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
										<p class="caption mb-0 font-weight-bold white--text">Cambiar Estado</p>
									</v-list-item>
									<v-list-item-group color="#524D4D">
										<v-list-item
											v-for="(status, index) in preprojectStatuses"
											:key="'pps'+index"
											dense
											@click.stop="() => { selectRow(item); changePreprojectStatus(item.id, status.value); }"
										>
											<v-list-item-title dense>
												{{ status.title }}
											</v-list-item-title>
										</v-list-item>
									</v-list-item-group>
								</v-list>
							</v-menu>
						</div>
					</div>
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mx-1"
								icon
								dark
								x-small
								color="#959595"
								@click.stop="() => { selectRow(item); toPreProjectDetail(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-information-variant-circle-outline</v-icon>
							</v-btn>
						</template>
						<span>Ver Detalle</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mx-1"
								icon
								dark
								x-small
								:color="item.budget ? 'green':'#524D4D'"
								@click.stop="() => { selectRow(item); openBudgetModal(item); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-table-cog</v-icon>
							</v-btn>
						</template>
						<span>Gestionar Presupuesto Desarchivo</span>
					</v-tooltip>
					<v-tooltip bottom v-if="item.project?.contract">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mx-1"
								icon
								dark
								x-small
								color="green"
								@click.stop="() => { selectRow(item); $router.push({ name: 'ContractDetail', query: { id: item.project?.contract.id } }); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-briefcase-eye</v-icon>
							</v-btn>
						</template>
						<span>Ir al Contrato</span>
					</v-tooltip>
					<v-tooltip bottom v-else>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mx-1"
								icon
								dark
								x-small
								color="green"
								@click.stop="() => { selectRow(item); openNewProjectModal({...item, ...{doc_type: 1}}); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-briefcase-outline</v-icon>
							</v-btn>
						</template>
						<span>Pasar a Contrato</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								class="mx-1"
								icon
								dark
								x-small
								color="warning"
								@click.stop="() => { selectRow(item); openNewProjectModal({...item, ...{doc_type: 2}}); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-book-outline</v-icon>
							</v-btn>
						</template>
						<span>Pasar a Presupuesto</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="error"
								class="mx-1"
								@click.stop="() => { selectRow(item); archivePreProject(item.id); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-archive-arrow-down-outline</v-icon>
							</v-btn>
						</template>
						<span>Archivar</span>
					</v-tooltip>
					<v-tooltip bottom v-if="$checkPermissions(['delete_crm'])">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="error"
								class="mx-1"
								@click.stop="() => { selectRow(item); startRemovePreProject(item.id); }"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon small dark>mdi-delete-outline</v-icon>
							</v-btn>
						</template>
						<span>Eliminar</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.preprojects.preProjectsCount"
				:loading-info="$store.state.preprojects.loadingPreProjects"
				:showOrderBy="true"
				items-type="preprojects"
			/>
		</div> -->
	</v-container>
</template>

<script>
import moment from 'moment'
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {sendScheduleEmail} from '@/helpers/api/conversations'
import {updatePreProjectInfo, setResponsible, archivePreProject, deletePreProject, addNewStatus} from '@/helpers/api/preprojects'
import {createBudget} from '@/helpers/api/budgets'
import {resizableGrid} from '@/helpers/resize-table'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'
import ProjectLineAssociationIcons from '@/components/Views/Projects/Parts/ProjectLineAssociationIcons'
import ProjectTypeSelectorMenu from '@/components/Helpers/Components/ProjectTypeSelectorMenu'

export default {
	name: 'PreProjectsIndex',
	components: {
		DataTablePagination,
		ProjectLineAssociationMenu,
		ProjectLineAssociationIcons,
		ProjectTypeSelectorMenu
	},
	data() {
		return {
			search: '',
			selectedRowItem: null,
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
				order_by: localStorage.getItem('preprojects_order_by') ? parseInt(localStorage.getItem('preprojects_order_by')) : 1,
      },
			preprojectStatuses: [
				{value: 1, title: 'En recopilación de antecedentes'},
				{value: 2, title: 'Pasó a presupuesto'},
				{value: 3, title: 'Pasó a contrato'},
				{value: 4, title: 'Rechazado'},
			],
			searchCity: '',
			cityMenu: false,
			columnWidths: {},
			unarchive: [
				{ id: 1, loading: false, text: 'CIP', label: 'Certificado de Informes Previos' },
				{ id: 2, loading: false, text: 'CVS', label: 'Certificado de Vivienda Social' },
				{ id: 3, loading: false, text: 'CE', label: 'Certificado Expropiación' },
				{ id: 4, loading: false, text: 'CN', label: 'Certificado de Número' },
				{ id: 5, loading: false, text: 'CUS', label: 'Certificado Uso de Suelo' },
				{ id: 6, loading: false, text: 'PE', label: 'Permiso de Edificación' },
				{ id: 7, loading: false, text: 'RD', label: 'Recepción Definitiva' },
				{ id: 8, loading: false, text: 'RC', label: 'Resolución Copropiedad' },
				{ id: 9, loading: false, text: 'CPA', label: 'Copia Plano Arquitectura' },
				{ id: 10, loading: false, text: 'CPL', label: 'Copia Plano Estructura' },
				{ id: 11, loading: false, text: 'CPC', label: 'Copia Plano Copropiedad' },
				{ id: 12, loading: false, text: 'CPLO', label: 'Copia Plano Loteo' },
				{ id: 13, loading: false, text: 'CPSP', label: 'Copia Plano Subdivisión Predial' }
			],
			cbr: [
				{ id: 14, loading: false, text: 'PT', label: 'Copia Plano Terreno' },
				{ id: 15, loading: false, text: 'CPSP', label: 'Copia Plano Subdivisión Predial' },
				{ id: 16, loading: false, text: 'CDV', label: 'Certificado Dominio Vigente' }
			],
			sii: [
				{ id: 17, loading: false, text: 'CAFD', label: 'Certificado Avalúo Fiscal Detallado' }
			],
			instalations: [
				{ id: 18, loading: false, text: 'PA', label: 'Planos Agua Potable y Alcantarillado' }
			],
			sec: [
				{ id: 19, loading: false, text: 'CTPE', label: 'Copia TE1 y Planos Eléctricos' },
				{ id: 20, loading: false, text: 'CTOPG', label: 'Copia TC6 u Otros y Planos de Gas' }
			]
		};
	},
	computed: {
		cities(){
			return this.$store.state.general.countryCities.filter(city => city.name.toLowerCase().includes(this.searchCity.toLowerCase()))
		},
		headers(){
			let headers = [
				{ text: 'Línea de Proyecto', value: 'id', width: '75px', sortable: false },
				{ text: 'Cliente', align: 'start', value: 'client', sortable: false },
				{ text: 'Dirección', align: 'start', value: 'address', sortable: false },
				{ text: 'Rol', align: 'start', value: 'rol', sortable: false },
				{ text: 'Proyecto', align: 'start', value: 'project_name', sortable: false },
				{ text: 'Municipalidad', align: 'start', value: 'entity', sortable: false },
				{ text: 'Desarchivo Municipal', value: 'unarchive', sortable: false },
				{ text: 'CBR', value: 'cbr', sortable: false },
				{ text: 'SII', value: 'sii', sortable: false },
				{ text: 'Sanitario', value: 'instalations', sortable: false },
				{ text: 'SEC', value: 'sec', sortable: false },
				{ text: 'Responsable', value: 'responsible', sortable: false },
				{ text: 'Observación', value: 'observation', sortable: false },
				{ text: 'Estado', value: 'status', sortable: false },
				{ text: 'Acciones', align: 'start', value: 'actions', sortable: false },
			]
			// return headers
			if(!this.$vuetify.breakpoint.mobile){
				const storedWidths = JSON.parse(localStorage.getItem('preProjectsColumnWidths')) || {};
				headers = headers.map((header) => {
					return {
						...header,
						width: storedWidths[header.value] || 'auto'
					}
				})
			}
			return headers.filter((header) => {
				return this.$store.state.preprojects.listingColumns[header.value]
			})
		},
		filteredUsers() {
			return this.$store.state.users.usersList.filter(user => {
				return (
					user.name.toLowerCase().includes(this.search.toLowerCase()) ||
					user.email.toLowerCase().includes(this.search.toLowerCase())
				);
			});
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		loadingPreProjects(){
			return this.$store.state.preprojects.loadingPreProjects
		},
		budgetModal(){
			return this.$store.state.general.newBudgetModal
		},
		newProjectModal(){
			return this.$store.state.projects.projectModal
		}
	},
	watch: {
    options: {
      handler() {
				this.debounceReloadInfo()
      },
      deep: true,
    },
		budgetModal(newValue){
			if(!newValue || (newValue && !newValue.status)){
				this.debounceReloadInfo()
			}
		},
		selectedCompany(newValue){
			if(newValue){
				this.debounceReloadInfo()
				this.$store.dispatch('users/getUserFromCompany')
				this.$store.dispatch('projects/getAllZoneIpts')
			}
		},
		loadingPreProjects(newValue){
			if(!newValue){
				this.$nextTick(() => {
					setTimeout(() => {
						resizableGrid(this.$refs.table.$el)
					}, 300);
				})
			}
		},
		newProjectModal(newValue, oldValue){
			if(!newValue && oldValue){
				this.debounceReloadInfo()
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.debounceReloadInfo()
			this.$store.dispatch('users/getUserFromCompany')
			this.$store.dispatch('projects/getAllZoneIpts')
		}
		const savedWidths = JSON.parse(localStorage.getItem('preProjectsColumnWidths'));
		if (savedWidths) {
			this.columnWidths = savedWidths;
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_preproject_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
    eventBus.$on('changeGeneralOrderList', this.onChangeGeneralOrderList)
    eventBus.$on('reloadInformation', this.debounceReloadInfo)
	},
	beforeDestroy(){
    eventBus.$off('changeGeneralOrderList', this.onChangeGeneralOrderList)
		eventBus.$off('reloadInformation', this.debounceReloadInfo)
	},
	methods: {
		onChangeGeneralOrderList(value){
			this.options.order_by = value
			this.debounceReloadInfo()
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_preproject_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		async changePreprojectStatus(preproject_id, status){
			const resp = await addNewStatus({preproject_id, status})
			if(resp.code == 200){
				this.reloadInfo()
			}
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('preprojects/getPreProjects', data)
		},
		getUserName(item){
			let name = ''
			if(item.client && item.client.profile){
				name = item.client.profile.name + ' ' + item.client.profile.lastname + ' ' + item.client.profile.second_lastname
			}
			else{
				name = 'No identificado'
			}
			return name
		},
		openNewProjectModal(preproject){
			const data = {...preproject, preproject_id: preproject.id}
			// console.log('[DEBUG] preproject data to send to project modal', data)
			this.$store.commit('projects/setProjectModalInfo', data)
			this.$store.commit('projects/setProjectModal', true)
		},
		async openBudgetModal(preproject){
			let budget = preproject.budget
			if(!budget){
				const budgetCreate = await createBudget({
					item_type: 'preproject',
					item_id: preproject.id
				})
				if(budgetCreate.code == 200){
					budget = budgetCreate.budget
				}
			}
			
			if(budget){
				localStorage.setItem('last_working_budget', JSON.stringify(budget))
				this.$router.push({ name: 'BudgetDetail', query: { id: budget.id } })
			}
		},
		status(preproject, documentTypeId){
			const base = [
				{ icon: 'mdi-check-circle-outline', label: 'Entregado', color: 'green' },
				{ icon: 'mdi-timer-sand', label: 'En Espera', color: 'orange' },
				{ icon: 'mdi-progress-alert', label: 'Atrasado', color: 'red' }
			]
			const found = preproject.documents.find((document) => {
				return document.document_type_id == documentTypeId
			})

			if (found) {
				if (found.delivered_date) {
					return base[0];
				}
				if (!found.max_date || ( found.max_date && moment().isBefore(found.max_date) ) ) {
					return base[1];
				}
				if (found.max_date && moment().isAfter(found.max_date)) {
					return base[2];
				}
			}
			return null;
		},
		getPreProjectDocument(preproject, documentTypeId){
			return preproject.documents.find((document) => {
				return document.document_type_id == documentTypeId
			})
		},
		getRandomArray(length){
			const base = [
				{ icon: 'mdi-check-circle-outline', label: 'Completado', color: 'green' },
				{ icon: 'mdi-timer-sand', label: 'En Espera', color: 'orange' },
				{ icon: 'mdi-progress-alert', label: 'Atrasado', color: 'red' }
			]
			let array = []
			for (let index = 0; index < length; index++) {
				array.push(base[Math.floor(Math.random() * 3)])
			}
			return array
		},
		toPreProjectsStart(crm){
			const preproject_info = {
				crm_id: crm.id,
				client_id: crm.user.user_id
			}
			localStorage.setItem('new_preproject_info', JSON.stringify(preproject_info));
			this.$store.commit('preprojects/setNewPreProjectModal', true)
		},
		saveColumnWidth(index) {
			const header_value = this.headers[index].value
			const headerCell = this.$refs.table.$el.querySelectorAll('.header-cell')[index];
			const newWidth = headerCell.offsetWidth;
			this.$set(this.columnWidths, header_value, newWidth);
			localStorage.setItem('preProjectsColumnWidths', JSON.stringify(this.columnWidths));
		},
		async archivePreProject(preproject_id){
			await archivePreProject({preproject_id})
			this.debounceReloadInfo()
		},
		startRemovePreProject(preproject_id){
			const confirmation = confirm("¿Estás seguro que quieres eliminar el registro?")
			if(confirmation){
				this.removePreProject(preproject_id)
			}
		},
		async removePreProject(preproject_id){
			await deletePreProject({preproject_id})
			this.debounceReloadInfo()
		},
		async resendPaymentRequest(conversation){
			try {
				await sendScheduleEmail({schedule_id: conversation.schedule.id})
				const data = {
					message: 'El correo con la solicitud de pago ha sido enviado al usuario.',
					title: 'Correo enviado correctamente',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
				this.$store.dispatch('crm/getConversations')
			} catch {
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error al enviar el correo',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
		},
		sentEmailDiff(conversation){
			if(conversation.schedule && conversation.schedule.request_email.length > 0){
				const current = moment()
				const startTime = conversation.schedule.request_email[0].created_at
				var duration = moment.duration(current.diff(startTime))
				var hours = duration.asHours()
				return hours
			}
			else if(conversation.schedule.request_email.length == 0){
				return -1
			}
			return null
		},
		addUser() {
			this.$store.commit('users/setNewUserModal', true)
		},
		toPreProjectDetail(preproject) {
			this.$router.push({ name: 'PreProject', params: { id: preproject.id } })
		},
		closeAllMenus() {
			Object.keys(this.$refs).forEach((refName) => {
				if (refName.startsWith("cityMenu-")) {
					const menu = this.$refs[refName];
					if (menu) {
						menu.isActive = false;
					}
				}
			});
		},
		async changePreProjectCity(item, district_id){
			const data = {
				preproject_id: item.id,
				district_id
			}
			await updatePreProjectInfo(data)
			this.debounceReloadInfo()
			this.searchCity = ''
      this.closeAllMenus()
		},
		async changeProjectType(item, project_type_id){
			const data = {
				preproject_id: item.id,
				project_type_id
			}
			await updatePreProjectInfo(data)
			this.debounceReloadInfo()
      this.closeAllMenus()
		},
		async changePreProjectResponsible(item, responsible_id){
			const data = {
				preproject_id: item.id,
				responsible_id
			}
			await setResponsible(data)
			this.debounceReloadInfo()
		},
	}
};
</script>

<style>
	.crm-index .message-container{
		margin-bottom: 0;
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.crm-index .message-container p{
		margin-bottom: 0;
		font-size: 12px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.crm-table table tr td{
		font-size: 11px!important;
	}
	.crm-table.resizable .v-data-table__wrapper th,
	.crm-table.resizable .v-data-table__wrapper td {
		border-right: 1px solid #cacaca;
	}
	.tooltip-arc-status{
    opacity: 1!important;
		background-color: white!important;
		border: 1px solid #524D4D;
		color: #524D4D;
	}
</style>
<style scoped>
	.menu-bg-white{background: white;}
	.subcolumn-header {
		text-align: center;
		border-top: 1px solid #ccc;
		border-right: 1px solid #ccc;
	}
	.subcolumn {
		text-align: center;
		border-right: 1px solid #ccc;
		align-content: center;
	}
	.subcolumn-header.no-border {
		border-right: none;
	}
	.subcolumn.no-border {
		border-right: none;
	}
</style>